import { useMutation, useQueryClient } from '@tanstack/react-query';
import { OWASReportService } from '@/infra/services/owas-report';
import { OWAS_QUERY_KEYS } from '../enums';

const Service = OWASReportService.getInstance();

export const useUpdateOWAS = () => {
	const queryClient = useQueryClient();
	return useMutation((params: any) => Service.update(params), {
		onSuccess: () => {
			queryClient.invalidateQueries([OWAS_QUERY_KEYS.GET_REPORT, OWAS_QUERY_KEYS.GET_FRAMES]);
		}
	});
};
